export const esData = `
<div class="page-title">TÉRMINOS Y CONDICIONES</div>
<div class="paragraph">
<div class="text-box">
  <div class="text">
  Este Servicio de Recompra ("Servicio") es proporcionado por Danghuan Europe S.L., una empresa constituida conforme a la legislación española y registrada en Madrid, España, 28045, con NIF: B19961911, correo electrónico: legal@danghuan.eu.
  </div>
  <div class="text">
  Este documento regula el marco legal bajo el cual los consumidores residentes en la Unión Europea pueden participar en el programa oficial de recompra vinculado a la compra de determinados smartphones. El programa se opera en pleno cumplimiento con la legislación de la Unión Europea, en particular la Directiva 2011/83/UE sobre los derechos de los consumidores y el Reglamento (UE) 2016/679 (GDPR) sobre protección de datos.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 1 – ALCANCE TERRITORIAL Y PRODUCTOS</div>
<div class="text-box">
  <div class="text">
  1.1. El Servicio está disponible para personas físicas que residan legalmente en la Unión Europea y que tengan al menos 18 años de edad. Actualmente el servicio de canje no está disponible en Islas Canarias ni Baleares.
  </div>
  <div class="text">
  1.2. Los participantes deben cumplir con la definición de "consumidores" según la Directiva 2011/83/UE.
  </div>
  <div class="text">
  1.3. Se podrá entregar un solo teléfono móvil usado por cada transacción válida.
  </div>
  <div class="text">
  1.4. La elegibilidad para la recompra está restringida a clientes que adquieran productos promocionales de VIVO en vivoonlinestore.com durante el período de campaña definido. Solo ciertos productos de VIVO califican.
  </div>
  <div class="text">
  1.5. El dispositivo usado debe estar incluido en la lista de dispositivos elegibles publicada en el sitio web de Danghuan y debe cumplir con los criterios de funcionamiento y propiedad descritos en el Artículo 5.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 2 – CONDICIONES CONTRACTUALES</div>
<div class="text-box">
  <div class="text">
  2.1. El Servicio de recompra es independiente de cualquier venta de producto y no constituye una oferta conjunta con ningún fabricante de dispositivos ni minorista.
  </div>
  <div class="text">
  2.2. Todas las responsabilidades del servicio, incluyendo logística, evaluación, comunicación, pago y tratamiento de datos, son asumidas exclusivamente por Danghuan Europe S.L.
  </div>
  <div class="text">
  2.3. Nada de lo dispuesto en estos Términos afecta los derechos obligatorios de protección al consumidor establecidos por la legislación de la UE.
  </div>
  <div class="text">
  2.4. Danghuan se reserva el derecho de rechazar la participación si se sospecha fraude o violación de las políticas, incluyendo casos en que terceros realicen solicitudes en nombre de otros usuarios.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 3 – PROCESO DE PARTICIPACIÓN EN EL SERVICIO</div>
<div class="text-box">
  <div class="text">
  3.1. Los consumidores deben iniciar el proceso de recompra haciendo clic en el botón Recompra en vivoonlinestore.com. Esto los redirigirá al portal de recompra operado por Danghuan Europe S.L., donde deberán completar el pedido.
  </div>
  <div class="text">
  3.2. Los participantes deberán completar un cuestionario de autoevaluación y enviar el IMEI del dispositivo.
  </div>
  <div class="text">
  3.3. Los clientes deben proporcionar datos válidos de una cuenta bancaria SEPA (IBAN) para recibir el pago.
  </div>
  <div class="text">
  3.4. Si no se completa el proceso dentro del plazo establecido, el servicio de recompra podrá cancelarse automáticamente.
  </div>
  <div class="text">
  3.5. Los envíos incompletos o con datos incorrectos podrán dar lugar a la cancelación del servicio.
  </div>
  <div class="text">
  3.6. El dispositivo usado debe estar correctamente embalado conforme a las instrucciones de envío proporcionadas. El envío es prepagado y Danghuan asume la responsabilidad por daños o pérdidas durante el transporte.
  </div>
  <div class="text">
  3.7. Una vez realizado correctamente el pedido de recompra, el cliente será redirigido automáticamente a vivoonlinestore.com para confirmar el pago del nuevo dispositivo VIVO.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 4 – CONDICIONES DE ACEPTACIÓN DEL DISPOSITIVO</div>
<div class="text-box">
  <div class="text">
  4.1. Solo se aceptan modelos de smartphones incluidos en la lista de dispositivos elegibles.
  </div>
  <div class="text">
  4.2. Los dispositivos deben cumplir con los estándares de clasificación estética definidos por Danghuan, categorizados como Grado A, B o C según herramientas de inspección certificadas y el estado físico.
  </div>
  <div class="text">
  4.3. Los dispositivos deben encender, tener pantalla táctil funcional, no presentar daños físicos graves (por ejemplo, grietas o corrosión), y deben estar restaurados a los ajustes de fábrica, con todos los bloqueos de seguridad desactivados (PIN, iCloud, Google, Samsung, Xiaomi).
  </div>
  <div class="text">
  4.4. Los dispositivos deben ser propiedad exclusiva del participante y no estar sujetos a contratos de arrendamiento o financiación. Los dispositivos reportados como robados, falsificados o con IMEI alterado serán rechazados sin compensación.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 5 – PLAZOS Y OBLIGACIONES LOGÍSTICAS</div>
<div class="text-box">
  <div class="text">
  5.1. Los clientes deben enviar su dispositivo usado en un plazo de 10 días naturales desde la realización exitosa del pedido de recompra.
  </div>
  <div class="text">
  5.2. Danghuan enviará correos electrónicos de recordatorio al cliente en el Día 3 (D+3), Día 6 (D+6) y Día 9 (D+9). El recordatorio enviado el Día 9 será la última notificación antes de la cancelación automática.
  </div>
  <div class="text">
  5.3. Todos los dispositivos deben enviarse utilizando la etiqueta de envío prepagada proporcionada por el proveedor logístico designado (como CORREOS, UPS, NACEX o FEDEX), según las instrucciones enviadas al cliente. Solo los envíos realizados con la etiqueta autorizada y a través del transportista indicado estarán cubiertos por la política de responsabilidad del servicio de recompra.
  </div>
  <div class="text">
  5.4. Si la etiqueta de envío no ha sido escaneada por el transportista antes del Día 10, el servicio de recompra se cancelará automáticamente.
  </div>
  <div class="text">
  5.5. Los dispositivos deben estar embalados de forma segura para evitar daños durante el transporte; Danghuan proporciona instrucciones de embalaje, pero no materiales físicos.
  </div>
  <div class="text">
  5.6. Los dispositivos recibidos con un IMEI que no coincida o en condiciones distintas a las declaradas podrán dar lugar a una revalorización o cancelación del servicio.
  </div>
  <div class="text">
  5.7. Si el cliente no envía el dispositivo dentro del plazo de 10 días, Danghuan Europe S.L. se reserva el derecho de cerrar la transacción y considerar que el cliente ha abandonado el proceso de recompra sin derecho a compensación.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 6 – INSPECCIÓN, VALORACIÓN Y ACEPTACIÓN</div>
<div class="text-box">
  <div class="text">
  6.1. Los dispositivos se inspeccionarán dentro de los 3 días laborables desde su recepción en el almacén designado. La inspección incluye un diagnóstico funcional mediante herramientas certificadas y una evaluación visual del estado estético (Grado A, B o C).
  </div>
  <div class="text">
  6.2. Si el estado o las especificaciones del dispositivo difieren de lo declarado por el cliente, Danghuan Europe S.L. enviará una nueva valoración por correo electrónico, especificando el grado ajustado y el motivo.
  </div>
  <div class="text">
  6.3. El cliente dispondrá de 7 días naturales desde la fecha de notificación para aceptar o rechazar la nueva valoración. Durante ese periodo podrá solicitar la devolución gratuita del dispositivo.
  </div>
  <div class="text">
  6.4. Si no se recibe respuesta dentro de los 7 días naturales, se considerará que el cliente acepta tácitamente la nueva valoración y el proceso de recompra continuará con el valor actualizado.
  </div>
  <div class="text">
  6.5. Los dispositivos considerados no elegibles debido a daños irreparables, manipulación, o ineligibilidad (por ejemplo, bloqueo iCloud, IMEI alterado o robado) no recibirán valoración. El cliente tendrá 7 días naturales desde la notificación para solicitar la devolución; de lo contrario, el dispositivo podrá ser reciclado de forma responsable.
  </div>
  <div class="text">
  6.6. El pago por los dispositivos aceptados se realizará en un plazo de 3 días laborables desde la fecha de aceptación, mediante transferencia bancaria SEPA.
  </div>
  <div class="text">
  6.7. Criterios de Clasificación de Dispositivos:
  </div>
  <div class="text">
  Todos los dispositivos elegibles serán clasificados según las siguientes categorías, las cuales determinarán su valor final de recompra:
  </div>
  <div class="text1">
  • Grade A – Excelente estado
  </div>
  <div class="text2">
   Completamente funcional; sin problemas técnicos.
  </div>
  <div class="text2">
   Sin daños visibles, grietas ni arañazos profundos.
  </div>
  <div class="text2">
   Pantalla y carcasa en estado casi perfecto.
  </div>
  <div class="text2">
   El dispositivo enciende y funciona sin estar conectado al cargador.
  </div>
  <div class="text2">
   Sin signos de manipulación o reparaciones no autorizadas.
  </div>
  <div class="text1">
  • Grade B – Buen estado
  </div>
  <div class="text2">
   Completamente funcional; desgaste estético leve.
  </div>
  <div class="text2">
   Arañazos superficiales en pantalla o carcasa.
  </div>
  <div class="text2">
   Sin grietas ni abolladuras profundas.
  </div>
  <div class="text2">
   Funcionamiento normal de botones y conectividad.
  </div>
  <div class="text2">
   Puede mostrar signos de uso regular, pero sin defectos funcionales.
  </div>
  <div class="text1">
  • Grade C – Estado aceptable
  </div>
  <div class="text2">
   El dispositivo funciona, pero presenta daños externos visibles.
  </div>
  <div class="text2">
   Arañazos, grietas en la pantalla o parte trasera, decoloraciones o pequeñas abolladuras.
  </div>
  <div class="text2">
   Todas las funciones deben operar correctamente (pantalla táctil, batería, WiFi, etc.).
  </div>
  <div class="text2">
   Aceptado para recompra, pero con un valor significativamente reducido.
  </div>
  <div class="text1">
  • Grado D o No Elegible
  </div>
  <div class="text2">
   El dispositivo no enciende, presenta defectos graves de hardware o no está desbloqueado/restablecido.
  </div>
  <div class="text2">
   Dispositivos que no cumplen los requisitos básicos de elegibilidad (por ejemplo, en lista negra, robados, bloqueados o con IMEI no coincidente).
  </div>
  <div class="text">
  6.8. Los dispositivos marcados como con IMEI no coincidente o en lista negra serán excluidos. Si el cliente considera que esta evaluación es errónea, podrá enviar documentación justificativa en un plazo de 7 días naturales para su revisión.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 7 – CONDICIONES DE PAGO</div>
<div class="text-box">
  <div class="text">
  7.1. Los pagos se realizan exclusivamente mediante transferencia bancaria SEPA a una cuenta a nombre del cliente, tal como fue proporcionada durante el proceso de registro de la recompra.
  </div>
  <div class="text">
  7.2. El IBAN proporcionado debe estar vinculado a una entidad financiera válida dentro de Europa y permanecer activo durante al menos 12 meses después de su envío.
  </div>
  <div class="text">
  7.3. Los IBAN o cuentas bancarias que no coincidan con el nombre del cliente provocarán el fallo del pago y la posible cancelación de la operación de recompra.
  </div>
  <div class="text">
  7.4. Danghuan Europe S.L. no se hace responsable de retrasos o errores ocasionados por datos bancarios incompletos, incorrectos o caducados.
  </div>
  <div class="text">
  7.5. El cliente es el único responsable de proporcionar información de pago precisa y completa, incluyendo un IBAN SEPA válido registrado a su nombre. Danghuan Europe S.L. no será responsable de ningún retraso, fallo o transferencia errónea causada por datos bancarios incorrectos, incompletos, caducados o no autorizados por parte del cliente.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 8 – RESPONSABILIDAD Y PÉRDIDA</div>
<div class="text-box">
  <div class="text">
  8.1. Los participantes deben utilizar la etiqueta de envío prepagada y el proveedor logístico designado por Danghuan Europe S.L. Cualquier método de envío alternativo anulará la cobertura de responsabilidad.
  </div>
  <div class="text">
  8.2. Un dispositivo se considerará perdido si no ha sido rastreado, confirmado ni recibido por Danghuan Europe S.L. dentro de los 15 días naturales desde su entrega al proveedor logístico.
  </div>
  <div class="text">
  8.3. Este marco de responsabilidad se aplica tanto a los envíos del cliente a Danghuan Europe S.L. como a cualquier devolución desde Danghuan Europe S.L. al cliente.
  </div>
  <div class="text">
  8.4. En caso de pérdida confirmada bajo el sistema logístico de Danghuan, Danghuan Europe S.L. ayudará al cliente a presentar una reclamación formal ante el servicio de mensajería.
  </div>
  <div class="text">
  8.5. La responsabilidad y la compensación están estrictamente limitadas a los casos en los que el cliente haya utilizado la etiqueta autorizada proporcionada por Danghuan Europe S.L., y el evento de envío sea verificable.
  </div>
  <div class="text">
  8.6. En tales casos de pérdida, la compensación no superará el valor final estimado del dispositivo antes de la confirmación de la pérdida.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 9 – DATOS PERSONALES Y CUMPLIMIENTO CON EL RGPD</div>
<div class="text-box">
  <div class="text">
  9.1. Todos los datos personales proporcionados por los clientes durante la participación en el programa de recompra son tratados en pleno cumplimiento con el Reglamento (UE) 2016/679 (RGPD) sobre protección de datos personales. Danghuan Europe S.L. actúa como Responsable del Tratamiento y aplica medidas técnicas y organizativas adecuadas para garantizar la seguridad y confidencialidad de los datos.
  </div>
  <div class="text">
  9.2. Los datos recogidos incluyen, entre otros: nombre, apellidos, dirección de correo electrónico, dirección postal, número de teléfono, cuenta bancaria (IBAN), documentos de identificación, IMEI del dispositivo entregado y respuestas proporcionadas en el formulario de evaluación.
  </div>
  <div class="text">
  9.3. Los datos son tratados exclusivamente con fines de verificación de identidad, tramitación y evaluación de la solicitud de recompra, gestión del envío y recogida del dispositivo, atención al cliente, contabilidad y ejecución del pago. Ningún dato personal será utilizado con fines comerciales ni compartido con terceros sin consentimiento explícito, salvo cuando sea exigido por ley.
  </div>
  <div class="text">
  9.4. Los datos se conservarán solo durante el tiempo necesario para completar la transacción y cumplir con las obligaciones legales aplicables. Salvo exigencia legal, todos los datos del cliente serán eliminados en un plazo de 30 días naturales tras la finalización del proceso y el pago correspondiente.
  </div>
  <div class="text">
  9.5. Es responsabilidad exclusiva del cliente eliminar de forma segura toda información personal del dispositivo antes del envío. Esto incluye contactos, mensajes, imágenes, aplicaciones, correos electrónicos, historial de navegación, cuentas y cualquier contenido confidencial.
  </div>
  <div class="text">
  9.6. El cliente también debe retirar cualquier tarjeta SIM o microSD activa y desactivar todas las funciones de seguridad, como bloqueos de pantalla, contraseñas y cuentas en la nube vinculadas (por ejemplo, Apple iCloud, cuenta de Google, Samsung Find My Mobile). No hacerlo puede dar lugar a que el dispositivo sea considerado no elegible.
  </div>
  <div class="text">
  9.7. Información adicional sobre el tratamiento de datos y los derechos del cliente (acceso, rectificación, supresión, limitación, oposición) está disponible en la Política de Privacidad completa publicada en el sitio web oficial de Danghuan Europe S.L.
  </div>
  <div class="text">
  9.8. Para los dispositivos que no hayan sido restablecidos correctamente, Danghuan Europe S.L. intentará aplicar un proceso certificado de borrado de datos, pero no se hace responsable de posibles datos personales residuales.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 10 – POLÍTICA CONTRA EL FRAUDE Y EL INCUMPLIMIENTO</div>
<div class="text-box">
  <div class="text">
  10.1. Las solicitudes que impliquen declaraciones falsas, dispositivos en lista negra, alquilados, manipulados o no pertenecientes al cliente serán descalificadas sin compensación.
  </div>
  <div class="text">
  10.2. Danghuan Europe S.L. se reserva el derecho de excluir a estos participantes de iniciativas de recompra actuales y futuras.
  </div>
  <div class="text">
  10.3. En los casos de fraude, suplantación de identidad o intentos de eludir los requisitos de elegibilidad con fines comerciales, se podrán iniciar acciones legales.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 11 – FUERZA MAYOR</div>
<div class="text-box">
  <div class="text">
  11.1. En caso de catástrofes naturales, restricciones gubernamentales, pandemias, huelgas o interrupciones del transporte fuera del control razonable, Danghuan Europe S.L. podrá suspender temporalmente el servicio de recompra sin asumir responsabilidad.
  </div>
  <div class="text">
  11.2. Cualquier retraso o incumplimiento derivado de tales eventos de fuerza mayor no será considerado un incumplimiento contractual.
  </div>
</div>
</div>

<div class="paragraph">
<div class="title">ARTÍCULO 12 – LEY APLICABLE Y JURISDICCIÓN</div>
<div class="text-box">
  <div class="text">
  12.1. Estos Términos y Condiciones se rigen e interpretan de conformidad con la legislación española.
  </div>
  <div class="text">
  12.2. Cualquier disputa que surja en relación con estos Términos estará sujeta a la jurisdicción exclusiva de los tribunales de Madrid, España, sin perjuicio de los derechos obligatorios de protección al consumidor en el país de residencia del cliente.
  </div>
</div>
</div>


`;
